import { useEffect, useState } from "react";
import { Volume2 } from "lucide-react";
import { isAlertSoundBlocked, playAlertSound, subscribeAlertSoundBlocked, unlockAlertSound } from "@/lib/alertSound";

/**
 * Shown when the browser blocked an alert sound because nobody has tapped the page
 * yet (a kitchen screen left open, a tablet woken from sleep). One tap turns sound on.
 */
export function SoundUnlockBanner() {
  const [blocked, setBlocked] = useState(isAlertSoundBlocked);

  useEffect(() => subscribeAlertSoundBlocked(setBlocked), []);

  if (!blocked) return null;

  return (
    <button
      type="button"
      onClick={async () => {
        await unlockAlertSound();
        void playAlertSound();
      }}
      className="fixed bottom-4 left-1/2 z-[100] flex -translate-x-1/2 items-center gap-2 rounded-full bg-primary px-5 py-3 text-sm font-semibold text-primary-foreground shadow-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      <Volume2 className="h-4 w-4" aria-hidden />
      Tap to turn on sound alerts
    </button>
  );
}
